import { Outlet, useLocation } from "react-router-dom";
import styled from "styled-components";
import { useSelector } from "react-redux";

import { LinkBtn } from "../../General";
import AllJobsWrapper from "../../../StylesWrappers/AllJobs/showAllJobs";
import { FilterJobs } from "..";
import { getToken } from "../../../utils/tokenStorage";
import { RootState } from "../../../store";

const JobPostsHeader = () => {
  const { engineeringPostJobs, postJobsCount } = useSelector(
    (store: RootState) => store.allPostJobsStore
  );

  const { pathname } = useLocation();

  const token = getToken();

  const jobCounter = (strPathname: string, unProStrPathname: string) => {
    if (pathname === strPathname || pathname === unProStrPathname) {
      if (pathname.includes("engineering-jobs")) {
        return `(${engineeringPostJobs?.length})`;
      }
      return `(${postJobsCount})`;
    }
    return "";
  };

  return (
    <AllJobsWrapper>
      <HeaderWrapper>
        <LinkBtn
          linkContent={`All jobs ${jobCounter(
            "/dashboard/all-post-jobs",
            "/all-post-jobs"
          )}`}
          url={token ? "/dashboard/all-post-jobs" : "/all-post-jobs"}
          linkBtn={`${!pathname.includes("engineering") ? "link__border" : ""}`}
          linkStyle="link__style"
        />
        <LinkBtn
          linkContent={`Engineering jobs ${jobCounter(
            "/dashboard/all-post-jobs/engineering-jobs",
            "/all-post-jobs/engineering-jobs"
          )}`}
          url={
            token
              ? "/dashboard/all-post-jobs/engineering-jobs"
              : "/all-post-jobs/engineering-jobs"
          }
          linkBtn={`${pathname.includes("engineering") ? "link__border" : ""}`}
          linkStyle="link__style"
        />
      </HeaderWrapper>

      {!token && (
        <LoginNoti>
          <p className="login__advice">
            Please register or login to enjoy all features
          </p>
        </LoginNoti>
      )}

      <FilterJobs />

      <Outlet />
    </AllJobsWrapper>
  );
};

export default JobPostsHeader;

const HeaderWrapper = styled.header`
  display: flex;
  gap: 5vw;
  @media screen and (max-width: 500px) {
    width: fit-content;
    margin-inline: auto;
    gap: 2rem;

    .link__style {
      font-size: 16px;
    }
  }

  .link__border {
    border-bottom: 2px solid #000;
    padding-bottom: 4px;
    padding-inline: 16px;
  }
`;

const LoginNoti = styled.div`
  .login__advice {
    color: #870505;
    font-size: 18px;
    font-weight: 600;
    margin-top: 8px;
  }
  @media screen and (max-width: 540px) {
    .login__advice {
      font-size: 14px;
    }
  }
`;
